import ContractParties from '@app/components/contract-parties';

import style from './contract-name.module.scss';

type Props = {
  agreement: Oneflow.Agreement;
};

export function ContractName({ agreement }: Props) {
  if (agreement.name) {
    return <div className={style.ContractName}>{agreement.name}</div>;
  }

  return <ContractParties agreement={agreement} />;
}
